<template>
  <div class="text-justify">
    <form
      ref="form"
      data-url="/details"
      class="mb-0"
      :class="{ 'loading-opacity': preloader }"
    >
      <Responsable
        v-for="(value, key) in inputs.details"
        :key="key"
        :inputs="value"
      />

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <input
              type="checkbox"
              v-model="inputs.accreditationApplication.other_activities"
              disabled
            />
            <label>{{ $t("other_activities") }}</label>
          </div>
        </div>
      </div>

      <div class="row" v-if="inputs.accreditationApplication.other_activities">
        <div class="col-md-12">
          <div class="form-group">
            <label>{{ $t("other_activities_description") }}</label>
            <app-input
              type="textarea"
              v-model="
                inputs.accreditationApplication.other_activities_description
              "
              :required="true"
              disabled
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>{{ $t("financing_operations") }}</label>
            <app-input
              type="textarea"
              v-model="inputs.accreditationApplication.financing_operations"
              :required="true"
              disabled
            />
          </div>
        </div>
      </div>

      <div class="row">
        <!-- <div class="col-12 mt-3">
          <button type="submit" class="btn btn-primary" @click.prevent="submit">
            {{ $t("save") }}
          </button>
        </div> -->
      </div>
    </form>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../apiUrl";
import Responsable from "./Responsable.vue";
export default {
  components: { Responsable },
  name: "Detail",
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {
        accreditationApplication: {
          other_activities: false,
          other_activities_description: null,
          financing_operations: null,
        },
        details: [
          {
            name: null,
            position: null,
            email: null,
            type_responsable: { name: null },
          },
          // {
          //   name: null,
          //   position: null,
          //   email: null,
          //   type_responsable: { name: null },
          // },
          // {
          //   name: null,
          //   position: null,
          //   email: null,
          //   type_responsable: { name: null },
          // },
        ],
      },
    };
  },
  created() {
    this.data();
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      this.save(this.inputs);
    },

    afterSuccess(res) {
      this.$toastr.s(res.data.message);
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    data() {
      this.preloader = true;

      this.axiosGet(
        `${actions.DETAILS}/show?accreditation_application_id=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            this.inputs.details = response.data ? response.data : {};
            this.inputs.accreditationApplication =
              response.data[0].accreditation_application;
          }
        })
        .catch((error) => {
          console.log("General: " + error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
